import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AdminForm from "../../AdminForm";
import {
  fetchVideo,
  selectLoading,
  selectVideoForEditing,
  setVideoForEdit,
  updateVideo,
} from "../videosAdminSlice";

const EditVideo = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const isLoading = useSelector(selectLoading);
  const field = useSelector(selectVideoForEditing);
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchVideo(id));
    return () => {
      dispatch(setVideoForEdit(undefined));
    };
  }, [id]);

  const onSubmit = (obj: any) => {
    const data = { id: id, data: obj };
    dispatch(
      updateVideo(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Промяна на видео"
      onSubmit={onSubmit}
      field={field}
      progress={progress}
    />
  );
};

export default EditVideo;
